/** Daily rate estimates (CAD) for the host earnings calculator — by city and vehicle class. */
export const HOST_CALCULATOR_CITIES = {
  Toronto: { economy: 95, sedan: 145, suv: 215, luxury: 380, sports: 410, electric: 295 },
  Vancouver: { economy: 100, sedan: 155, suv: 230, luxury: 350, sports: 330, electric: 290 },
  Montreal: { economy: 85, sedan: 130, suv: 200, luxury: 340, sports: 300, electric: 270 },
  Calgary: { economy: 80, sedan: 125, suv: 190, luxury: 320, sports: 285, electric: 250 },
  Ottawa: { economy: 78, sedan: 120, suv: 185, luxury: 310, sports: 275, electric: 245 },
  Brampton: { economy: 88, sedan: 133, suv: 198, luxury: 350, sports: 377, electric: 271 },
  Mississauga: { economy: 90, sedan: 138, suv: 204, luxury: 361, sports: 390, electric: 280 },
  Hamilton: { economy: 81, sedan: 123, suv: 183, luxury: 323, sports: 349, electric: 251 },
  Edmonton: { economy: 80, sedan: 125, suv: 190, luxury: 320, sports: 285, electric: 250 },
  Winnipeg: { economy: 72, sedan: 115, suv: 172, luxury: 285, sports: 258, electric: 220 },
  Halifax: { economy: 76, sedan: 118, suv: 178, luxury: 298, sports: 265, electric: 238 },
  "Quebec City": { economy: 82, sedan: 125, suv: 192, luxury: 325, sports: 287, electric: 258 },
  Victoria: { economy: 96, sedan: 148, suv: 218, luxury: 335, sports: 315, electric: 278 },
  Other: { economy: 75, sedan: 120, suv: 180, luxury: 300, sports: 270, electric: 230 },
};
